import {useTranslation} from "react-i18next";
import React from "react";
import {FormControlLabel, IconButton, Menu } from "@mui/material";
import Paper from "@mui/material/Paper";
import { Settings as SettingsIcon } from '@vedmarket/ui-kit';
import {COLORS} from "../../../../../../../../../../../../../config/constants";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";

const ACTIVE_COLUMNS_MIN = [
  "id",
  "name",
  "settings",
];

export const ACTIVE_COLUMNS_BY_DEFAULT = [
  "id",
  "name",
  "contract_num",
  "contract_date",
  "contact",
  "additional_info",
  "settings",
];

const SupplierSettingsPanel = ({
  activeColumns,
  handleSelect,
  setActiveColumns,
}: SupplierSettingsPanelProps) => {

  const { t } = useTranslation()

  const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);
  const [ selectedAll, setSelectedAll ] = React.useState(true);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSelectAll = () => {
    setActiveColumns(selectedAll ? [ ...ACTIVE_COLUMNS_MIN ] : [ ...ACTIVE_COLUMNS_BY_DEFAULT ])
    setSelectedAll(!selectedAll);
  }

  const getSettingsColumnName = (columnId: string) => {
    switch (columnId) {
      case "contract_num":
        return t("calc__text__main__contractNumber");
      case "contract_date":
        return t("calc__text__main__contractDate");
      case "contact":
        return t("calc__text__main__addressPhoneContactPerson");
      case "additional_info":
        return t("calc__text__main__comments");
      default:
        return "";
    }
  }

  // @ts-ignore
  return <>
    <IconButton
      aria-label='settings'
      sx={{
        color: COLORS.LIGHT_ACTION,
        padding: "12px 0",
      }}
      aria-controls={open ? "supplier-settings-panel" : undefined}
      aria-haspopup
      aria-expanded={open ? "true" : undefined}
      onClick={handleClick}
    >
      <SettingsIcon />
    </IconButton>
    <Menu
      id='supplier-settings-panel'
      aria-labelledby='supplier-settings-panel'
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      sx={{
        ".MuiPaper-rounded": {
          margin: 0,
        },
        ".MuiButtonBase-root": {
          minHeight: "40px"
        },
      }}
    >
      <Paper
        className='supplier-select-modal__settings-panel'
        sx={{
          margin: 0,
          width: "320px",
        }}
      >
        <div className='supplier-select-modal__settings-container'>
          {ACTIVE_COLUMNS_BY_DEFAULT
            .filter((columnId) => ![ "id", "name", "settings" ].includes(columnId))
            .map((columnId) => (
              <FormControlLabel
                key={columnId}
                control={<Checkbox
                  checked={activeColumns.includes(columnId)}
                  onChange={() => handleSelect(columnId)}
                  sx={{ padding: "0 8px" }}
                />}
                sx={{
                  marginLeft: "4px",
                  ".MuiFormControlLabel-label": {
                    fontSize: "16px"
                  }
                }}
                label={getSettingsColumnName(columnId)}
              />
            ))}
        </div>
        <Divider sx={{ marginTop: 0 }}/>
        <div className='supplier-select-modal__settings-container'>
          <FormControlLabel
            key='select-all'
            control={<Checkbox
              checked={selectedAll}
              onChange={handleChangeSelectAll}
              sx={{ padding: "0 8px" }}
            />}
            sx={{
              marginLeft: "4px",
              ".MuiFormControlLabel-label": {
                fontSize: "16px"
              }
            }}
            label={t("calc__text__packaging__showHideEverything")}
          />
        </div>
      </Paper>
    </Menu>
  </>
}

export default SupplierSettingsPanel
